export default "__VITE_ASSET__ZfojLTyLoZjYVmH6_74xTg__"